export const getDistance = (start, end) => {
    const a = start.x - end.x;
    const b = start.y - end.y;
    return Math.sqrt(a * a + b * b);
};

export const getAngle = (start, end) => {
    return Math.atan2(end.y - start.y, end.x - start.x);
};